const TAB_LABEL_BY_KEY = {
  embed: 'Embed',
  player: 'Player',
  chapters: 'Chapters',
  captions: 'Captions',
  clips: 'Clips',
  schedule: 'Schedule',
  analytics: 'Analytics',
}

const TAB_KEY_BY_LABEL = Object.fromEntries(
  Object.entries(TAB_LABEL_BY_KEY).map(([key, label]) => [label.toLowerCase(), key]),
)

/** @returns {string} internal tab key */
export function parseTabQuery(value) {
  if (value == null || value === '') return 'embed'
  const raw = String(value).trim()
  const byKey = TAB_KEY_BY_LABEL[raw.toLowerCase()]
  if (byKey) return byKey
  if (Object.prototype.hasOwnProperty.call(TAB_LABEL_BY_KEY, raw)) return raw
  return 'embed'
}

export function tabKeyToQueryLabel(key) {
  return TAB_LABEL_BY_KEY[key] || TAB_LABEL_BY_KEY.embed
}

/** @param {Record<string, string>} query */
export function applyTabToQuery(query, tabKey) {
  const next = { ...query }
  if (!tabKey || tabKey === 'embed') {
    delete next.tab
  } else {
    next.tab = tabKeyToQueryLabel(tabKey)
  }
  return next
}

/** @returns {'poster' | 'animated' | 'end'} */
export function parseMediaQuery(value) {
  if (value == null || value === '') return 'poster'
  const v = String(value).trim().toLowerCase()
  if (v === 'endposter' || v === 'end') return 'end'
  if (v === 'animated') return 'animated'
  if (v === 'poster') return 'poster'
  return 'poster'
}

export function mediaAssetToQuery(asset) {
  if (asset === 'end') return 'endPoster'
  return asset
}

/** @param {Record<string, string>} query */
export function applyMediaToQuery(query, asset) {
  const next = { ...query }
  if (!asset || asset === 'poster') {
    delete next.media
  } else {
    next.media = mediaAssetToQuery(asset)
  }
  return next
}

export { TAB_LABEL_BY_KEY }
